export default __webpack_public_path__ + "static/media/Frame 18413.0d0ad431.svg";